import axios from "../config/axiosConfig";
import DisplaySuccess from "../component/statusComponents/displaySuccess";
import DisplayError from "../component/statusComponents/displayError/displayError";

export async function login(email = "", password = "") {
  try {
    const response = await axios.post(
      "/users/login",
      {
        email,
        password,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const userData = response.data;
    console.log("userData", userData);
    localStorage.setItem("userLoginRequestID", userData?.userId);
    return { success: true, msg: "ssssss", userData };
  } catch (error) {
    if (error.response?.data) {
      console.error("API Error:", error.response.data);
      const { data } = error.response;

      return {
        success: false,
        msg: data.message,
      };
    } else {
      console.error("Login service error:", error.message);
      return {
        success: false,
        msg: "Une erreur s'est produite lors de la tentative de connexion",
      };
    }
  }
}
export async function requestPasswordReset(email = "") {
  try {
    const response = await axios.post("/users/request-password-reset", {
      email,
    });

    const userId = response.data?.userId;
    return { success: true, userId, msg: "" };
  } catch (error) {
    if (error.response?.data) {
      console.error("requestPasswordReset API Error:", error.response.data);
      const { data } = error.response;

      return {
        success: false,
        msg: data.message,
      };
    } else {
      console.error("requestPasswordReset API Error:", error.message);
      return {
        success: false,
        msg: "Une erreur s'est produite lors de la tentative de réinitialisation de votre mot de passe. Veuillez réessayer.",
      };
    }
  }
}

export async function resetPassword(
  userId = "",
  resetPasswordCode = "",
  newPassword = ""
) {
  try {
    const response = await axios.post("/users/reset-password", {
      userId,
      resetPasswordCode,
      newPassword,
    });

    localStorage.removeItem("userResetPwdRequestID");
    localStorage.removeItem("resetPwdCode");
    return { success: true, msg: "" };
  } catch (error) {
    if (error.response?.data) {
      console.error("resetPassword API Error:", error.response.data);
      const { data } = error.response;

      return {
        success: false,
        msg: data.message,
      };
    } else {
      console.error("resetPassword API Error:", error.message);
      return {
        success: false,
        msg: "Une erreur s'est produite lors de la tentative de réinitialisation de votre mot de passe. Veuillez réessayer.",
      };
    }
  }
}
export async function getClients(save) {
  const ress = await axios
    .get(`/users/clients`) // Fetch clients instead of all users
    .then((result) => {
      // if (save) {
      if (result.data.error === false) {
        return result.data.data; // Return the clients' data
        // if (save) {
        //   save(result.data.data); // Save the clients' data to state
        //   console.log(result.data.data);
        //   return result.data.data;
        // } else {
        //   return result.data.data;
        // }
      } else {
        DisplayError(result.data.message);
        // if (save) {
        //   save([]); // Clear the clients list in case of error
        // } else {
        //   return [];
        // }
      }
      return;
      // }
    })
    .catch((error) => {
      if (error?.response?.status !== 401) {
        DisplayError();
      }
    });
  return ress;
}

export async function getAllUsers(save) {
  await axios
    .get(`/users`)
    .then((result) => {
      if (save) {
        if (result.data.error === false) {
          if (save) {
            save(result.data.data);
          } else {
            return result.data.data;
          }
        } else {
          DisplayError(result.data.message);
          if (save) {
            save([]);
          } else {
            return [];
          }
        }
        return;
      }
    })
    .catch((error) => {
      if (error?.response?.status !== 401) {
        DisplayError();
      }
    });
}
export async function updateUserStatus(id, data) {
  try {
    await axios
      .put(`/users/status/${id}`, data)
      ?.then((response) => {
        DisplaySuccess(response?.data?.status, response?.data?.message);
      })
      ?.catch((error) => {
        DisplaySuccess(
          error?.response?.data?.status,
          error?.response?.data?.message
        );
        return false;
      });
  } catch (error) {
    DisplaySuccess(
      error?.response?.data?.status,
      error?.response?.data?.message
    );
  }
}
export async function createOrUpdateUser(dataToSend, type, id, save, refresh) {
  try {
    let url = "";
    if (type === "edit") {
      url = `/users/${id}`;
    } else {
      url = `/users/create`;
    }
    const formData = new FormData();
    Object.keys(dataToSend).map((key) => {
      formData.append(`${key}`, dataToSend[`${key}`]);
    });

    await axios
      .post(url, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((result) => {
        if (save) {
          save({});
        }
        if (refresh) {
          refresh();
        }
        DisplaySuccess(result?.data?.status, result?.message);
      })
      .catch((error) => {
        if (error?.response?.status !== 401) {
          DisplayError();
        }
      });
  } catch (error) {
    DisplayError();
  }
}

export async function getUserByID(id, save) {
  try {
    const result = await axios.get(`/users/${id}`);

    // if (result?.data?.error === false) {
    if (result) {
      let data = result?.data;
      if (save) {
        console.log("🚀 ~ data:", data);

        save(data); // Save the data if the save callback is provided
      } else {
        return data; // Return the data if no callback is provided
      }
    } else {
      DisplayError(result.data.message); // Handle any error message from the backend
      if (save) {
        save([]); // If there's an error, save an empty array or handle it as needed
      } else {
        return [];
      }
    }
  } catch (error) {
    if (error?.response?.status !== 401) {
      DisplayError(); // Display error if there's an issue with the API call
    }
  }
}

export async function sendDemandeDevis(data) {
  try {
    const response = axios.post(`users/send-abonnement`, data);
    return response;
  } catch (error) {
    throw new Error(
      "Erreur lors de la création de la abonnement : " + error.message
    );
  }
}

export async function deleteClient(id, save) {
  try {
    await axios.delete(`/users/${id}`);
    if (save) {
      save((prev) => prev.filter((client) => client._id !== id));
    }
    DisplaySuccess("success", "Client supprimé avec succès");
  } catch (error) {
    if (error?.response?.status !== 401) {
      DisplayError();
    }
  }
}
export const updateClientStatus = async (id, status) => {
  const response = await axios.patch(`/users/${id}/status`, { status });
  return response.data;
};

export async function addUser(data) {
  try {
    const response = await axios.post("/users/register", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(
      "Erreur lors de l'ajout de l'utilisateur : " + error.message
    );
  }
}
export const getVisitors = async () => {
  const res = await axios.get("/users/visitors"); // ou un endpoint spécifique si disponible
  console.log("getVisitors response:", res.data);
  return res.data;
};
// Modifier un utilisateur (changer rôle par ex.)
export const updateUser = async (id, data) => {
  const res = await axios.patch(`/users/${id}`, data);
  return res.data;
};
// Supprimer un deleteUserAndDevis
export const deleteClientAndDevis = async (id) => {
  try {
    const response = await axios.delete(`/users/${id}`); // Make sure this matches your backend endpoint
    return response.data;
  } catch (error) {
    console.error("Error deleting user and devis", error);
    throw error; // Handle errors properly
  }
};
